<div class="loading-container">
  <div class="loading-content">
    <div class="loading-logo">
      <app-company-logo></app-company-logo>
    </div>
    @if (spinner) {
      <div class="loading-spinner">
        <span class="loader"> </span>
      </div>
    }
    @if (progressBar) {
      <div class="loading-progressBar">
        <p id="loadingProgressLabel" class="loading-text">
          {{ currentMessage }}
        </p>
        <mat-progress-bar mode="determinate" [value]="value" aria-labelledby="loadingProgressLabel"> </mat-progress-bar>
      </div>
    }
  </div>
</div>
